import { Component, Injector, OnInit } from '@angular/core';
import { FcGenericItemModalBaseComponent, FcListValidationService } from '../../generic';
import { FcModifyPersonWebAccountListItemDto, FcPersonWebAccountListItemDto, FormGroupValidationRules, SystemGuid, WebAccessTypeEnum } from 'webcommon/shared';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcItemModalMode } from '../../../models/FcItemModalContext';
import { ApFindControlService } from '../../ap-findcontrol.service';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-person-web-account-list-modal',
  templateUrl: './fc-person-web-account-list-modal.component.html',
  styleUrls: ['./fc-person-web-account-list-modal.component.less']
})
export class FcPersonWebAccountListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public password = '';

  public listItem: FcPersonWebAccountListItemDto = {
    Id: '',
    UserName: '',
    Password: '',
    PatientWebAccess: false,
    FacilityPortalWebAccess: false,
    LimitedTimePassword: false,
    PersonUid: '',
  };

  public listItemDefaultValidation: FormGroupValidationRules = {
    UserName: {
      IsRequired: true,
      MaxLength: 256,
    },
  };

  public userNameControl = new FormControl<string>('');
  public passwordControl = new FormControl<string>('');
  public activeControl = new FormControl<boolean>(false);
  public limitedTimePasswordControl = new FormControl<boolean>(false);
  public personUidControl = new FormControl<string>('');
  public facilityPortalWebAccessControl = new FormControl<boolean>(false);
  public form = new FormGroup({
    userName: this.userNameControl,
    password: this.passwordControl,
    active: this.activeControl,
    limitedTimePassword: this.limitedTimePasswordControl,
    personUid: this.personUidControl,
    facilityPortalWebAccess: this.facilityPortalWebAccessControl,
  });

  constructor(
    injector: Injector,
    private apFindControlService: ApFindControlService,
  ) {
    super(injector);
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.loadListItem(this.listItemDefaultValidation);
  }

  public setForm(): void {
    // User Name Control
    this.userNameControl.setValidators(this.fcListValidation.getValidators('UserName'));
    this.userNameControl.setValue(this.listItem.UserName);

    // PasFsword Control
    this.passwordControl.setValue(this.listItem.Password);
    if (this.fcModalItemContext.mode === FcItemModalMode.NewRelItem) {
      const newPassword = this.generatePassword();
      this.passwordControl.setValue(newPassword);
    }
    this.passwordControl.disable();

    // Activate Control
    this.activeControl.setValue(this.listItem.PatientWebAccess);

    // Limited Password Control
    if (this.fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.limitedTimePasswordControl.disable();
    }
    this.limitedTimePasswordControl.setValue(this.listItem.LimitedTimePassword);

    // PersonUid Control
    this.personUidControl.setValue(this.listItem.PersonUid);

    // FacilityPortalWebAccess Control
    this.setFacilityPortalWebAccessValue();
    this.facilityPortalWebAccessControl.setValue(this.listItem.FacilityPortalWebAccess);
  }

  public resetWebAccount(): void {
    const newPassword = this.generatePassword();
    this.password = newPassword;
    this.passwordControl.markAsDirty();
    this.limitedTimePasswordControl.enable();
  }

  public generatePassword(): string {
    const minLength = 6;
    const maxLength = 16;
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%~&*()';
    const passwordLength = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
    let password = '';
    for (let i = 0; i < passwordLength; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  }

  public override save(): void {
    this.checkEmailIntergationPartnerEnabling();
    const values = this.form.getRawValue();
    this.isSubmitted = true;

    const modifyItemDto: FcModifyPersonWebAccountListItemDto = {
      UserName: values.userName as string,
      Password: values.password as string,
      PatientWebAccess: values.active as boolean,
      LimitedTimePassword: values.limitedTimePassword as boolean,
      PersonUid: values.personUid as string,
      FacilityPortalWebAccess: values.facilityPortalWebAccess as boolean,
    };
    super.save<FcModifyPersonWebAccountListItemDto>(modifyItemDto);
  }

  private setFacilityPortalWebAccessValue(): void {
    if (this.fcModalItemContext.mode === FcItemModalMode.NewRelItem &&
      this.fcModalItemContext.webAccessType === WebAccessTypeEnum.FacilityPortal) {
        this.listItem.FacilityPortalWebAccess = true;
      }
  }

  private checkEmailIntergationPartnerEnabling(): void {
    this.apFindControlService.getItem<any>('IntegrationPartner', SystemGuid.IntegrationPartnerUid)
      .pipe(this.takeUntilDestroy())
      .subscribe((res: FcPersonWebAccountListItemDto) => {
        if (res.Inactive) {
          this.showNotificationEmailIntegration();
        }
      });
  }

  private showNotificationEmailIntegration(): void {
    const infoTitle = 'Unable to Send Notification';
    const infoMessage = 'Email integration partner needs to be enabled.';
    this.apNotificationService.warning(infoMessage, infoTitle);
  }
}
